import React, { useState, useEffect } from 'react'

import { useInView } from 'react-cool-inview'

import { classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import axios from 'axios'
import { shape, oneOfType, string, number, array, arrayOf, object, bool } from 'prop-types'

import BrowseAllButton from 'Pods/Shared/BrowseAllButton'
import useSentry from 'Pods/Shared/Hooks/useSentry'
import i18n from 'Pods/Shared/I18nHome'
import { modelsPath } from 'Pods/Shared/paths'
import DesignerInfo from 'Pods/Shared/PrintModels/components/DesignerInfo'
import DesignerModel from 'Pods/Shared/PrintModels/components/DesignerModel'

function NewDesignerSection({ userInfo, locale, showTitle = true, className = '' }) {
  const [wasViewed, setWasViewed] = useState(false)
  const browseAllButton = i18n.t('trendingSection.browseButton', { ns: 'new-home', lng: locale })
  const featuredDesignerTitle = i18n.t('featuredDesigner.title', { ns: 'new-home', lng: locale })
  const totalModelText = i18n.t('featuredDesigner.models', { ns: 'new-home', lng: locale })
  const browseAllButtonPath = modelsPath(locale, { author: userInfo.user.username })
  const { captureException } = useSentry()

  const { observe } = useInView({
    threshold: 0.5,
    onEnter: ({ unobserve }) => {
      if (!wasViewed) {
        setWasViewed(true)
      }
      unobserve()
    },
  })

  useEffect(() => {
    if (wasViewed && userInfo && userInfo.id) {
      axios.post(`/api/internal/featured_designers/${userInfo.id}/track`).catch(() => {
        if (window.Sentry) {
          captureException(new Error('Failed to track featured designer'))
        }
      })
    }
  }, [wasViewed, userInfo])

  if (!userInfo || !userInfo.id) return null

  return (
    <div
      className={classnames('featured-designer-section', className)}
      data-user-id={userInfo.user.id}
      ref={observe}
    >
      <div className="featured-designer-section__header">
        {showTitle && <h2 className="cgt-legacy-heading-h3 cgt-mb-20">{featuredDesignerTitle}</h2>}
        <BrowseAllButton
          href={browseAllButtonPath}
          text={browseAllButton}
          className="browse-all-desktop"
        />
      </div>

      <div className="row">
        <div className="col-12 designer-promotions-row">
          <div className="designer-promotions-row__container">
            <div className="designer-promotions-row__list">
              <div className="designer-promotions-row__item">
                <DesignerInfo user={userInfo.user} keywords={userInfo.keywords} totalModelText={totalModelText} />
              </div>
              {userInfo.products.slice(0, 3).map((product, index) => (
                <div className="designer-promotions-row__item" key={index}>
                  <DesignerModel {...product} />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <BrowseAllButton
        href={browseAllButtonPath}
        text={browseAllButton}
        className="browse-all-mobile cgt-mt-20"
      />
    </div>
  )
}

NewDesignerSection.propTypes = {
  userInfo: shape({
    id: oneOfType([string, number]).isRequired,
    user: shape({
      id: oneOfType([string, number]).isRequired,
      username: string.isRequired,
    }).isRequired,
    keywords: array,
    products: arrayOf(object).isRequired,
  }).isRequired,
  locale: string.isRequired,
  showTitle: bool,
  className: string,
}

export default NewDesignerSection
